import Button from 'components/Button'
import styled from 'styled-components'

export default styled(Button)`
  width: 100%;
  text-align: left;
`
